import React from 'react';
import { designConstants } from '../../design/styles';
import { withTheme } from '../../design/styles/useThemeContext';

class Chevron extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this._d = 'M0 6 L6 ' + (this.props.expanded ? 1 : 11).toString() + ' L12 6';
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.expanded !== this.props.expanded) {
      this._d = 'M0 6 L6 ' + (props.expanded ? 1 : 11).toString() + ' L12 6';
    }
  }
  render() {
    const { colors } = this.props.theme;
    let d = this._d;
    return (
      <svg height="12" width="12">
        <path
          ref={(path) => (this._path = path)}
          d={d}
          fill="none"
          stroke={colors.darkGrayRecords}
          strokeWidth={2}
          strokeLineJoin="miter"
          strokeLineCap="round"
        />
      </svg>
    );
  }
}

export default withTheme(Chevron);
